import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/Home.vue'
import Empresa from '../pages/Empresa.vue'
import Educacional from '../pages/Educacional.vue'
import Ambiental from '../pages/Ambiental.vue'
import Cidada from '../pages/Cidada.vue'
import Clientes from '../pages/Clientes.vue'
import Administrativo from '../pages/AdministrativoPage.vue'
import Desenvolvedor from '../pages/DesenvolvedorPage.vue'
import DesenvolvedorEstagio from '../pages/DesenvolvedorEstagioPage.vue'
import Designer from '../pages/DesignerPage.vue'
import DesignerEstagio from '../pages/DesignerEstagioPage.vue'
import Secretario from '../pages/SecretarioPage.vue'
import SecretarioEstagio from '../pages/SecretarioEstagioPage.vue'
import Suporte from '../pages/SuportePage.vue'
import SuporteEstagio from '../pages/SuporteEstagioPage.vue'
import PoliticaCookies from '../components/politica/PoliticaCookies.vue'
import PoliticaPrivacidade from '../components/politica/PoliticaPrivacidade.vue'

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/sobre',
    name: 'sobre',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../pages/Sobre.vue')
  },
  {
    path: '/empresa',
    name: 'empresa',
    component: () => import(/* webpackChunkName: "about" */ '../pages/Empresa.vue')
  },
  {
    path: '/educacional',
    name: 'educacional',
    component: () => import(/* webpackChunkName: "about" */ '../pages/Educacional.vue')
  },
  {
    path: '/ambiental',
    name: 'ambiental',
    component: () => import(/* webpackChunkName: "about" */ '../pages/Ambiental.vue')
  },
  {
    path: '/cidada',
    name: 'cidada',
    component: () => import(/* webpackChunkName: "about" */ '../pages/Cidada.vue')
  },
  {
    path: '/clientes',
    name: 'clientes',
    component: () => import(/* webpackChunkName: "about" */ '../pages/Clientes.vue')
  },
  {
    path: '/administrativo',
    name: 'administrativo',
    component: () => import(/* webpackChunkName: "about" */ '../pages/AdministrativoPage.vue')
  },
  {
    path: '/desenvolvedor',
    name: 'desenvolvedor',
    component: () => import(/* webpackChunkName: "about" */ '../pages/DesenvolvedorPage.vue')
  },
  {
    path: '/desenvolvedorEstagio',
    name: 'desenvolvedorEstagio',
    component: () => import(/* webpackChunkName: "about" */ '../pages/DesenvolvedorEstagioPage.vue')
  },
  {
    path: '/desenvolvedorPleno',
    name: 'desenvolvedorPleno',
    component: () => import(/* webpackChunkName: "about" */ '../pages/DesenvolvedorPlenoPage.vue')
  },
  {
    path: '/designer',
    name: 'designer',
    component: () => import(/* webpackChunkName: "about" */ '../pages/DesignerPage.vue')
  },
  {
    path: '/designerEstagio',
    name: 'designerEstagio',
    component: () => import(/* webpackChunkName: "about" */ '../pages/DesignerEstagioPage.vue')
  },
  {
    path: '/secretario',
    name: 'secretario',
    component: () => import(/* webpackChunkName: "about" */ '../pages/SecretarioPage.vue')
  },
  {
    path: '/secretarioEstagio',
    name: 'secretarioEstagio',
    component: () => import(/* webpackChunkName: "about" */ '../pages/SecretarioEstagioPage.vue')
  },
  {
    path: '/suporte',
    name: 'suporte',
    component: () => import(/* webpackChunkName: "about" */ '../pages/SuportePage.vue')
  },
  {
    path: '/suporteEstagio',
    name: 'suporteEstagio',
    component: () => import(/* webpackChunkName: "about" */ '../pages/SuporteEstagioPage.vue')
  },
  {
    path: '/politicaPrivacidade',
    name: 'politicaPrivacidade',
    component: () => import(/* webpackChunkName: "about" */ '../components/politica/PoliticaPrivacidade.vue')
  }

]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})


export default router
